import {type BaseLifecycleEventsFilters} from './lifecycle-events-params'

export const ACCOUNT_STATUS_EVENTS_QUERY_KEY = 'account-status-events'

export type AccountStatusEventsFilters = BaseLifecycleEventsFilters
